import {useState} from "react";
import Client from "../../../models/Client";
import {getAllClients} from "../../../shared/api/GetFormData";
import GenericDialog from "../../../shared/components/generic/dialog/GenericDialog";
import GenericTable, {TableOptions} from "../../../shared/components/generic/table/GenericTable";
import ClientForm from "./ClientForm";
import ClientTemplate from "./ClientTemplate";

const ClientList = () => {

    const [visibilityNewRequest, setVisibilityNewRequest] = useState(false);
    const [initialValues, setInitialValues] = useState<any | undefined>(undefined);
    const [dataFromChildCreate, setDataFromChildCreate] = useState<any | undefined>(undefined);
    const [visibilityColumnSelectionModal, setVisibilityColumnSelectionModal] = useState<boolean>(false);
    const [initialValuesColumnSelection, setInitialValuesColumnSelection] = useState<any | undefined>(undefined);

    const onHideColumnSelectionModal = () => {
        if (visibilityColumnSelectionModal) {
            setVisibilityColumnSelectionModal(false);
        }
    };

    const onHideNewRequest = () => {
        if (visibilityNewRequest) {
            setVisibilityNewRequest(false);
        }
    };

    const clientsTableOptions = {
        options: {
            title: "Pregled klijenata",
            toFetch: [getAllClients()],
            columns: {
                headers: ["Naziv", "Identifikator", "Adresa", "Aktivan"],
                fieldNames: ["name", "fullVat", "address", "isActive"],
                fieldTypes: ["string", "string", "string", "boolean"],
                searchByFieldNames: ["name", "identifier", "address", "fullVat"],
            },
            hasHeader: false,
            isDataMutable: true,
            expansionTemplate: (params: {e: Client, handleDataFromChild: () => void}) => <ClientTemplate entity={params.e} handleDataFromChild={params.handleDataFromChild}/>,
            modalOptions: {
                modals: [
                    <GenericDialog key="modal-new" headerText="Novi klijent" onHide={onHideNewRequest}
                        visible={visibilityNewRequest}
                        hasFooter={false}
                        children={<ClientForm hide={onHideNewRequest} initialValues={initialValues} addNewDataToTable={setDataFromChildCreate}
                            />} />,
                ],
                hideVariables: [
                    visibilityNewRequest,
                ],
                hideSetters: [
                    setVisibilityNewRequest,
                ],
                hideFunctions: [
                    onHideNewRequest,
                ],
                initialValues: {
                    initialValues: initialValues,
                    setInitialValues: setInitialValues
                },
                newValue: dataFromChildCreate
            },
            columnSelection:{
                headers: ["Naziv", "Identifikator", "Adresa", "Aktivan"],
                fieldNames: ["name", "fullVat", "address", "isActive"],
                hideVariables:visibilityColumnSelectionModal,
                hideSetters:setVisibilityColumnSelectionModal,
                hideFunctions:onHideColumnSelectionModal,
                initialValues:{
                    initialValues:initialValuesColumnSelection,
                    setInitialValues:setInitialValuesColumnSelection
                }
            }
        }
    } as TableOptions;

    return (
        <div>
            <GenericTable options={clientsTableOptions.options}></GenericTable>
        </div>
    );
}

export default ClientList;